// extracted by mini-css-extract-plugin
module.exports = {"mobileNavigation":"BottomNav-module--mobileNavigation--2NUIV","navContainer":"BottomNav-module--navContainer--2cfaw"};